module.exports = __webpack_public_path__ + "static/media/device-left-sidebar.1e4e84e1.png";